//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Select, SelectItem } from 'unison';

import { ConnectPanelActions } from '@catalog-ingestion/actions/connectPanelActions';
import { getLocaleOptions } from '@catalog-ingestion/constants/connectPanelConstants';
import { ICuralateStore } from '@models/AppState';
import { ReduxDispatch } from 'app/curalate.store';

function mapStateToProps(state: ICuralateStore) {
  return {
    selectedLocale: state.catalogIngestionReducers.connectPanel.selectedLocale,
  };
}

function mapDispatchToProps(dispatch: ReduxDispatch) {
  return {
    actions: {
      connectPanel: bindActionCreators(ConnectPanelActions, dispatch),
    },
  };
}

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export const SelectLocaleField = (props: Props) => {
  const {
    selectedLocale,
    actions: {
      connectPanel: {
        changeLocale,
      },
    },
  } = props;

  const localeOptions = getLocaleOptions();

  return (
    <>
      <div className='cu-text-subsection cu-mt-4'>
        Select a Locale
      </div>
      <div className='cu-text-body'>
        This locale (language and currency) will be used to detemine what currency to display on consumer-facing
        solutions.
      </div>
      <Select
        className='cu-mt-2'
        handleChange={ changeLocale }
        unselectedLabel={ selectedLocale }
        value={ selectedLocale }
        items={ localeOptions }
      >
        {
          localeOptions.map(({ label, value }) => {
            return (<SelectItem className='cu-mt-2' key={ label } label={ label } value={ value }/>);
          })
        }
      </Select>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectLocaleField);
